import { useSelector } from "react-redux";

import Modal from "@/components/ui/modal";
import { ROW_ID_DETAIL_DATASET } from "@/constants/dataset";
import { isNotAdminAreaLevel } from "@/helpers/datasetAttributeHelper";
import { RootState } from "@/store";
import { resetShowPanelDatasetDetail } from "@/store/slice/uiSlice";
import { SpatialAggregationType } from "@/types/common";
import { DatasetAttributeSchema } from "@/types/dataset";

import { DatasetDetailRow } from "../columns";
import { FormActionPanel } from "./FormActionPanel";

interface DetailActionPanelProps {
  schema: DatasetAttributeSchema[];
  spatialAggregationType: SpatialAggregationType | null;
  selectedRow: DatasetDetailRow | null;
  onSubmit: (data: Record<string, unknown>) => void;
  onEdit: (
    data: Record<string, unknown>,
    originalData?: DatasetDetailRow | null
  ) => void;
}

export const ActionPanel = ({
  schema,
  selectedRow,
  onSubmit,
  onEdit,
  spatialAggregationType
}: DetailActionPanelProps) => {
  const { showPanelDatasetDetail } = useSelector(
    (state: RootState) => state.ui
  );

  // Filter out attributes related to administrative areas data types
  const filteredSchema = schema.filter(
    (item) =>
      isNotAdminAreaLevel(item.attribute_code) &&
      item.attribute_code !== ROW_ID_DETAIL_DATASET
  );

  return (
    <Modal
      isOpen={
        !!(
          showPanelDatasetDetail?.isAddNewRow ||
          showPanelDatasetDetail?.isEditRow
        )
      }
      onClose={() => resetShowPanelDatasetDetail()}
      containerClassname="!static"
    >
      {showPanelDatasetDetail?.isAddNewRow && (
        <FormActionPanel
          fields={filteredSchema ?? []}
          onSubmit={onSubmit}
          spatialAggregationType={spatialAggregationType}
        />
      )}
      {showPanelDatasetDetail?.isEditRow && (
        <FormActionPanel
          fields={filteredSchema ?? []}
          initialValues={selectedRow}
          spatialAggregationType={spatialAggregationType}
          onSubmit={onEdit}
        />
      )}
    </Modal>
  );
};
